import React, {useEffect, useRef, useState} from "react";
import Carousel from "react-multi-carousel";
import "./style.scss";
import {CTKM_CAT_ID, CTKM_NEWS_ID, env_set} from 'global/environment';

import bullet_fire_ic from "assets/imgs/CTKMT7/megaphone1.png";
import bullet_calendar_ic from "assets/imgs/bulleticons/bullet_calendar_ic.png";
import bullet_coupon_ic from "assets/imgs/bulleticons/bullet_coupon_ic.png";
import bullet_dual_sim_ic from "assets/imgs/bulleticons/bullet_dual_sim_ic.png";
import bag_decor_img from "assets/imgs/CTKMDEALHOT15/right_decor.svg";
import vnpt_logo from "assets/imgs/CTKMJ2K/CTKMJ2K_VNPT_Logo.png";
import vnpt_logo_blue_desktop from "assets/imgs/CTKMT7/logo_VNPT_blue.png";
import header_title from "assets/imgs/CTKMT7/header_title.png";
import lazada from "assets/imgs/CTKMT7/banner.png";
import stepGetVoucher1 from "assets/imgs/CTKMT7/iPhone14_1.png";
import stepGetVoucher2 from "assets/imgs/CTKMT7/iPhone14_2.png";
import stepGetVoucher3 from "assets/imgs/CTKMT7/iPhone14_3.png";
import stepGetVoucher4 from "assets/imgs/CTKMT7/iPhone14_4.png";
import stepGetVoucher5 from "assets/imgs/CTKMT7/iPhone14_5.png";
import stepGetVoucher6 from "assets/imgs/CTKMT7/iPhone14_6.png";
import stepGetVoucher7 from "assets/imgs/CTKMT7/iPhone14_7.png";
import stepGetVoucher8 from "assets/imgs/CTKMT7/iPhone14_8.png";
import myvnpt_logo from "assets/imgs/CTKMT7/Logo_MyVNPT_Footer.png";
import qrcode from "assets/icons/QRStore.svg";
import iosStore from "assets/imgs/appstore.png";
import androiStore from "assets/imgs/ggplay.png";

const CTKMThang7 = () => {
  let refCarousel = useRef(null);
  const [showGetVoucher, setShowGetVoucher] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth > 991 ? false : true);
  const totalItemDisplay = useRef(0);

  const STORE_IOS = "https://apps.apple.com/vn/app/my-vnpt/id1017188399?l=vi";
  const STORE_ANDROID =
    "https://play.google.com/store/apps/details?id=com.vnp.myvinaphone&hl=vi";

  let ratio;
  let carousel_track_width;
  let carousel_track_image_width;
  let paging_slide_carousel_width;
  let paging_slide_carousel_dot_width;
  let totalItemNumber;
  let totalItemLeght;

  useEffect(() => {
    const handleLoad = () => {
      let carousel_track = document.getElementsByClassName(
        "react-multi-carousel-track"
      );
      let carousel_track_image =
        carousel_track[0].getElementsByClassName("image");
      let paging_slide_carousel = document.getElementsByClassName(
        "paging_slide_carousel"
      );
      let paging_slide_carousel_dot = document.getElementsByClassName(
        "paging_slide_carousel_dot"
      );
      totalItemDisplay.current = document.getElementsByClassName(
        "react-multi-carousel-item--active"
      ).length;

      carousel_track_width = carousel_track[0].clientWidth;
      carousel_track_image_width = carousel_track_image[0].clientWidth;
      paging_slide_carousel_width = paging_slide_carousel[0].clientWidth;
      ratio =
        (carousel_track_image_width / carousel_track_width) * totalItemDisplay.current;
      paging_slide_carousel_dot_width = paging_slide_carousel_width * ratio;

      totalItemNumber = getVoucher.image.length;
      totalItemLeght = totalItemNumber * carousel_track_image_width;

      paging_slide_carousel_dot[0].style.width =
        paging_slide_carousel_dot_width.toString() + "px";

      paging_slide_carousel_dot[0].style.transition = "400ms ease-in-out 0";

      if (window.innerWidth > 991) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    };

    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  //handlescroll
  useEffect(() => {
    let carousel_track = document.getElementsByClassName(
      "react-multi-carousel-track"
    );
    const getTranslateValues = (element) => {
      const style = window.getComputedStyle(element);
      const matrix =
        style["transform"] || style.webkitTransform || style.mozTransform;

      // Return early if no transform is defined
      if (!matrix || matrix === "none") return { x: 0, y: 0 };

      // Can either be 2d or 3d transform
      const matrixType = matrix.includes("3d") ? "3d" : "2d";
      const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(", ");

      // 2d matrices have 6 values, 3d have 16
      const translateX =
        matrixType === "3d"
          ? parseFloat(matrixValues[12])
          : parseFloat(matrixValues[4]);
      const translateY =
        matrixType === "3d"
          ? parseFloat(matrixValues[13])
          : parseFloat(matrixValues[5]);

      return { x: translateX, y: translateY };
    };

    const handleScroll = () => {
      // Your event handling logic here
      let currentCarouselPos = getTranslateValues(carousel_track[0]).x;
      let currentItem = (currentCarouselPos * -1) / carousel_track_image_width;
      if (currentCarouselPos === 0) {
        currentItem = 0;
      }
      currentItem = (currentItem / totalItemDisplay.current)
      let paging_slide_carousel_dot_pos =
        paging_slide_carousel_dot_width * currentItem;

      let paging_slide_carousel_dot = document.getElementsByClassName(
        "paging_slide_carousel_dot"
      );
      paging_slide_carousel_dot[0].style.transform =
        "translateX(" + paging_slide_carousel_dot_pos.toString() + "px)";
    };

    carousel_track[0].addEventListener("transitionend", handleScroll);

    return () => {
      carousel_track[0].removeEventListener("transitionend", handleScroll);
    };
  }, []);

  //handle resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
      ratio =
        (carousel_track_image_width / carousel_track_width) * totalItemDisplay.current;
      paging_slide_carousel_dot_width = paging_slide_carousel_width * ratio;
      let paging_slide_carousel_dot = document.getElementsByClassName(
        "paging_slide_carousel_dot"
      );
      paging_slide_carousel_dot[0].style.width =
        paging_slide_carousel_dot_width.toString() + "px";
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const getVoucher = {
    image: [
      stepGetVoucher1,
      stepGetVoucher2,
      stepGetVoucher3,
      stepGetVoucher4,
      stepGetVoucher5,
      stepGetVoucher6,
      stepGetVoucher7,
      stepGetVoucher8
    ],
    title: ["Bước 1", "Bước 2", "Bước 3", "Bước 4", "Bước 5", "Bước 6", "Bước 7", "Bước 8"],
    content: [
      `<b>Bước 1:</b> Đăng nhập ứng dụng My VNPT, chọn <span class="semi-bold">“VNPT Shop”</span>`,
      `<b>Bước 2:</b> Chọn <span class="semi-bold">"Mua gói cước di động"</span>`,
      `<b>Bước 3:</b> Lựa chọn gói cước phù hợp với bạn`,
      `<b>Bước 4:</b> Tại chi tiết gói cước di động, chọn <span class="semi-bold">"Mua ngay"</span>`,
      `<b>Bước 5:</b> Thay đổi <span class="semi-bold">"Phương thức thanh toán"</span> tại màn Thanh toán`,
      `<b>Bước 6:</b> Chọn Phương thức thanh toán <span class="semi-bold">được ghi nhận khuyến mại</span>`,
      `<b>Bước 7:</b> Thực hiện thanh toán bằng Phương thức đã chọn đến khi hiển thị màn xác nhận <span class="semi-bold">Giao dịch thành công</span>`,
      `<b>Bước 8:</b> Chờ nhận ưu đãi hoàn tiền trong vòng tối đa <span class="semi-bold">48 giờ</span>`,
    ],
  };

  return (
    <>
      <div id="CTKMT7" className="wrapper">
        <div className="background">
          <div className="bg_decor"></div>
          {/*<div className="right_decor">*/}
          {/*  <img src={bag_decor_img} />*/}
          {/*</div>*/}
        </div>
        <div className="contentwrapper">
          {isMobile === true && (
            <div className="logo">
              <img src={vnpt_logo} />
            </div>
          )}
          {isMobile === false && (
            <div className="logo_desktop">
              <img src={vnpt_logo_blue_desktop} alt="" width={138} height={32}/>
            </div>
          )}
          <div className="content">
            <div className="header_image">
              <img src={header_title} alt="" width={978.6667}/>
            </div>
            <div className="title" style={{marginTop: "10px"}}>
              Mua gói cước ngay<span className="title_span">Hoàn tiền liền tay 50%</span>
            </div>
            {!isMobile && (
                <div className="contentCTKM" style={{marginTop: "32px"}}>
                  <div className="contentCTKM_img">
                    <img src={bullet_fire_ic} alt="" srcSet=""/>
                  </div>
                  <div className="contentCTKM_content">
                    <span>Ưu đãi HOT diễn ra vào Chủ Nhật hàng tuần: Hoàn tiền 50% tối đa 20.000đ khi mua gói cước di động cho thuê bao trả trước</span>
                  </div>
                </div>
            )}

            {isMobile === false && (
              <div className="button_desktop" style={{ marginTop: "32px" }}>
                {env_set === 3 && (
                  <>
                    {/* staging */}
                    <a
                      className="secondary_button"
                      href={"https://my.vnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_NEWS_ID}//staging 5083
                    >
                      Xem thể lệ
                    </a>
                    <a
                      className="primary_button"
                      href={"https://my.vnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CAT_ID}
                    >
                      Đăng ký gói cước
                    </a>{" "}
                  </>
                )}
                {env_set === 2 && (
                  <>
                    {/* beta*/}
                    <a
                      className="secondary_button"
                      href={"https://my.vnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_NEWS_ID}//prod 5443
                    >
                      Xem thể lệ
                    </a>
                    <a
                      className="primary_button"
                      href={"https://my.vnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CAT_ID}
                    >
                      Đăng ký gói cước
                    </a>{" "}
                  </>
                )}
                {env_set === 1 && (
                  <>
                    {/* prod*/}
                    <a
                      className="secondary_button"
                      href={"https://stagingv2.myvnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_NEWS_ID}//prod 5443
                    >
                      Xem thể lệ
                    </a>
                    <a
                      className="primary_button"
                      href={"https://stagingv2.myvnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CAT_ID}
                    >
                      Đăng ký gói cước
                    </a>{" "}
                  </>
                )}
              </div>
            )}

            <div className="banner" style={{marginTop: isMobile ? "24px" : "32px"}}>
              <img src={lazada} alt=""/>
            </div>
            {/* <div className="subtitle" style={{ marginTop: "12px" }}>
              Ưu đãi hoàn tiền đăng ký gói cước! Độc quyền trên My VNPT!
            </div> */}
            <div className="contentCTKM_afterBanner" style={{marginTop: "24px"}}>
              <span className="contentCTKM_afterBanner_title">
                Ưu đãi HOT diễn ra vào Chủ Nhật hàng tuần: Hoàn tiền 50% tối đa 20.000đ khi mua gói cước di động cho thuê bao trả trước
              </span>
              {isMobile === true && (
                <>
                  <br />
                </>
              )}
              <br />
              {/*<span className="contentCTKM_afterBanner_title">*/}
              {/*  Duy nhất trên My VNPT!*/}
              {/*</span>*/}
              <br />
              <br />
              {isMobile === true && (
                <>
                  <div className="contentCTKM_afterBanner_content">
                    <div className="contentCTKM_afterBanner_img">
                      <img src={bullet_dual_sim_ic} alt="" srcset="" />
                    </div>
                    <span>Áp dụng cho thuê bao di động trả trước<br/>Không áp dụng với phương thức thanh toán Tài khoản chính</span>
                  </div>
                  <div className="contentCTKM_afterBanner_content">
                    <div className="contentCTKM_afterBanner_img">
                      <img src={bullet_calendar_ic} alt="" srcset="" />
                    </div>
                    <span>Thời gian diễn ra chương trình:<br/>Chủ Nhật hàng tuần từ ... đến ...</span>
                  </div>
                  <div className="contentCTKM_afterBanner_content">
                    <div className="contentCTKM_afterBanner_img">
                      <img src={bullet_coupon_ic} alt="" srcset="" />
                    </div>
                    {/*<span>Mỗi khách hàng nhận tối đa 1 ưu đãi/ngày,<br/>2 ưu đãi/tháng</span>*/}
                    <span>Mỗi khách hàng nhận tối đa 1 ưu đãi/ngày, 2 ưu đãi/tháng</span>
                  </div>
                </>
              )}

              {isMobile === false && (
                <div className="contentCTKM_afterBanner_desktop">
                  <div className="contentCTKM_afterBanner_desktop_content">
                    <div className="contentCTKM_afterBanner_desktop_img">
                      <img src={bullet_dual_sim_ic} alt="" srcSet="" />
                    </div>
                    <span>Áp dụng cho thuê bao di động trả trước<br/>Không áp dụng với phương thức<br/>thanh toán Tài khoản chính</span>
                  </div>
                  <div className="contentCTKM_afterBanner_desktop_content">
                    <div className="contentCTKM_afterBanner_desktop_img">
                      <img src={bullet_calendar_ic} alt="" srcSet="" />
                    </div>
                    <span>Thời gian diễn ra chương trình:<br/>Chủ Nhật hàng tuần từ ... đến ...</span>
                  </div>
                  <div className="contentCTKM_afterBanner_desktop_content">
                    <div className="contentCTKM_afterBanner_desktop_img">
                      <img src={bullet_coupon_ic} alt="" srcSet="" />
                    </div>
                    <span>Mỗi khách hàng nhận tối đa<br/>1 ưu đãi/ngày, 2 ưu đãi/tháng</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          {isMobile === true && (
            <>
              <div className="separate_graybar"></div>
            </>
          )}
          <div className="subtitle2" style={{ marginTop: "12px" }}>
            Hướng dẫn Đăng kí gói cước di động
          </div>
          <Carousel
            draggable={false}
            responsive={responsive}
            infinite={false}
            transitionDuration={0}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            ref={(el) => (refCarousel = el)}
            arrows={true}
            showDots={false}
            dotListClass="custom-dot-list-style"
            slidesToSlide={totalItemDisplay.current}
          >
            {getVoucher.title.map((item, index) => (
              <>
                <div className="image">
                  <img src={getVoucher.image[index]} alt="" />
                </div>
                <div
                  className="content-carousel"
                  style={{ marginTop: "12px" }}
                  dangerouslySetInnerHTML={{
                    __html: getVoucher.content[index],
                  }}
                />
              </>
            ))}
          </Carousel>
          <div className="paging_slide_carousel">
            <div className="paging_slide_carousel_dot"></div>
          </div>
          {isMobile === true && (
            <div className="buttons" style={{ marginTop: "86px" }}>
              {env_set === 3 && (
                <>
                  {/* staging */}
                  <a
                    className="secondary_button"
                    href={"https://my.vnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_NEWS_ID}//staging 5144
                  >
                    Xem thể lệ
                  </a>
                  <a
                    className="primary_button"
                    href={"https://my.vnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CAT_ID}
                  >
                    Đăng ký gói cước
                  </a>{" "}
                </>
              )}
              {env_set === 2 && (
                <>
                  {/* beta*/}
                  <a
                    className="secondary_button"
                    href={"https://my.vnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_NEWS_ID}//prod 5764
                  >
                    Xem thể lệ
                  </a>
                  <a
                    className="primary_button"
                    href={"https://my.vnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CAT_ID}
                  >
                    Đăng ký gói cước
                  </a>{" "}
                </>
              )}
              {env_set === 1 && (
                <>
                  {/* prod*/}
                  <a
                    className="secondary_button"
                    href={"https://stagingv2.myvnpt.com.vn/app?screenCode=NEWS_DETAIL&news_id=" + CTKM_NEWS_ID}//prod 5764
                  >
                    Xem thể lệ
                  </a>
                  <a
                    className="primary_button"
                    href={"https://stagingv2.myvnpt.com.vn/app?screenCode=PACKAGE_LIST&type=1&cat=" + CTKM_CAT_ID}
                  >
                    Đăng ký gói cước
                  </a>{" "}
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="footer_ctkm15">
        <div className="content_wrapper">
          <div className="icon_wrapper">
            <div className="logo">
              <img src={myvnpt_logo} alt="" srcset="" />
            </div>
            <div className="download">
              <div className="store_wrapper">
                <div className="icons">
                  <a href={STORE_IOS}><img src={iosStore} alt="" srcset="" /></a>
                  <a href={STORE_ANDROID}><img src={androiStore} alt="" srcset="" /></a>
                </div>
                <div className="text">Quét mã để tải ngay ứng dụng MyVNPT</div>
              </div>
              <div className="QRCODE">
                <img src={qrcode} alt="" srcset="" />
              </div>
            </div>
          </div>
          <div className="copyright">© 2018 Bản quyền của Tổng Công ty Truyền thông VNPT-Media</div>
        </div>

      </div>
    </>
  );
};

export default CTKMThang7;
